import sha256 from "./sha256.js";
import replaceAll from 'string.prototype.replaceall';
import randomColor from "randomcolor";

replaceAll.shim(); // will be a no-op if not needed

const Util = {
    // in seconds
    timestamp: () => {
        return Math.round((new Date()).getTime() / 1000);
    },

    // formatter for unsplash photo urls
    unsplashIdToSrc: (id, {quality, width, height} = {quality: 80, width: 1900, height: null}) => {
        if (id.includes("://") || id.startsWith("/")) return id;
        return `https://images.unsplash.com/${id}?q=${quality || 80}&w=${width}&h=${height}`;
    },

    // tale array, return object indexed by property
    indexBy: (arr, prop) => {
      let res = {};
      for (let item of (arr || [])) {
        res[item[prop]] = item;
      }
      return res;
    },

    sleep: (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    isString: (v) => {
        return typeof v === 'string' || v instanceof String;
    },

    isGuid: (v) => {
      return v && v.length == 36 && v.replaceAll("-", "").length == 32;
    },

    isFunction: (v) => typeof v === "function",

    hash: sha256,

    filterObjectProp: (object, id) => {
      return JSON.parse(
        JSON.stringify(object, function(key, value) {
          if (key != id) {
            return value;
          }
        })
      )
    },

    // https://stackoverflow.com/a/5767357
    removeItemOnce: (arr, value) => {
      let arr2 = [...arr];
      var index = arr.indexOf(value);
      if (index > -1) {
        arr2.splice(index, 1);
      }
      return arr2;
    },

    // https://stackoverflow.com/a/5767357
    removeItemAll: (arr, value) => {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },

    randomItem: (arr) => {
      return arr[Math.floor(Math.random() * arr.length)]
    },

    // ofcourse not really random or secure
    randomHash: () => Util.hash(Util.timestamp() + "" + Math.floor(Math.random() * Math.floor(9999999999999999))),

    randomColors: (count, options) => {
      let defaults = {
        count: count || 20,
        luminosity: 'bright',
        format: 'hex',
        alpha: 0.9
      };
      return randomColor({...defaults, ...(options || {})})
    },

    guidToColor: (guid, colors) => {
      let colorCount = 20;
      let hexValue = guid.split('-').join('');
      let value = parseInt(hexValue, 16);
      let maxValue = (Math.pow(16, hexValue.length)) * 1.0;
      let position = (value / maxValue);
      let normalizedIndex = Math.floor(position * colorCount);
      let palette = colors || Util.randomColors(colorCount);
      return palette[normalizedIndex];
    },

    /**
        auth: g3n1k
        mail: g3n1k@yahoo.com
        time: 18-July-2013
    */
    stringToSeo: (txt_src) => {
        var output = txt_src.replace(/[^a-zA-Z0-9]/g,' ').replace(/\s+/g,"-").toLowerCase();
        /* remove first dash */
        if(output.charAt(0) == '-') output = output.substring(1);
        /* remove last dash */
        var last = output.length-1;
        if(output.charAt(last) == '-') output = output.substring(0, last);

        return output;
    }
};

export default Util;